import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Project } from '@/hooks/content-generator/workbook-types';
import WorkbookCard from './WorkbookCard';

interface Props {
  workbook: Project;
  onClick?: (workbook: Project) => void;
}

const WorkbookCardDraggable: React.FC<Props> = ({ workbook, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: workbook.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <WorkbookCard
        project={workbook}
        onClick={() => onClick?.(workbook)}
        isDraggable={true}
        dragHandleProps={{ ...listeners, ...attributes }}
        isDragging={isDragging}
      />
    </div>
  );
};

export default WorkbookCardDraggable; 